import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import Firmaordning from "./pages/Firmaordning";
import About from "./pages/About";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Bestilling from "./pages/Bestilling";

// ScrollToTop helper component to scroll window to top on route change and update document title
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    // Map pathnames to page titles
    const titles = {
      "/": "Forside",
      "/menukort": "Menukort",
      "/firmaordning": "Firmaordning",
      "/om-os": "Om os",
      "/galleri": "Galleri",
      "/kontakt": "Kontakt",
      "/bestilling": "Bestilling"
    };

    const pageName = titles[pathname] || "Forside";
    document.title = `Hillerød Smørrebrød - ${pageName}`;
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="flex flex-col min-h-screen bg-white text-neutral-900 antialiased selection:bg-[#2d5a27] selection:text-white">
      <ScrollToTop />
      {/* Header Navigation */}
      <Header />

      {/* Main Content Area */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menukort" element={<Menu />} />
          <Route path="/firmaordning" element={<Firmaordning />} />
          <Route path="/om-os" element={<About />} />
          <Route path="/galleri" element={<Gallery />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/bestilling" element={<Bestilling />} />
          {/* Fallback route */}
          <Route path="*" element={<Home />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
